(function(){
  'use strict';
  var DATA=(window.vehicleFitmentData||[]).filter(function(x){return !x.status||String(x.status).toLowerCase()==='active'});
  var customizeLink=window.v2VfhFallbackUrl||'/pages/customize-your-wrap';
  var pageSize=4,shown=pageSize,currentGroups=[],currentMode='',currentLabel='';
  var selectedMake='',selectedModel='',selectedYear='';
  var preventGhostClickUntil=0;
  if(!document.getElementById('homepage-fitment-finder'))return;
  var el={
    search:document.getElementById('home-vf-search'),
    searchBtn:document.getElementById('home-vf-search-btn'),
    filterBtn:document.getElementById('home-vf-filter-btn'),
    make:document.getElementById('home-vf-make'),
    model:document.getElementById('home-vf-model'),
    year:document.getElementById('home-vf-year'),
    makeMenu:document.getElementById('home-vf-make-menu'),
    modelMenu:document.getElementById('home-vf-model-menu'),
    yearMenu:document.getElementById('home-vf-year-menu'),
    clear:document.getElementById('home-vf-clear'),
    results:document.getElementById('home-vf-results')
  };

  function esc(s){return String(s||'').replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
  function norm(s){return String(s||'').trim()}
  function lower(s){return norm(s).toLowerCase()}
  function uniq(arr){var seen={},out=[];arr.forEach(function(v){v=norm(v);var k=lower(v);if(v&&!seen[k]){seen[k]=1;out.push(v)}});return out.sort(function(a,b){return a.localeCompare(b,undefined,{numeric:true,sensitivity:'base'})})}
  function yearLabel(x){var a=norm(x.yearFrom),b=norm(x.yearTo);if(a&&b)return a===b?a:a+'-'+b;if(a)return a;if(b)return b;return 'Year not listed'}
  function countryLabel(x){return norm(x.country)||'Country not listed'}
  function coversYear(x,y){
    if(!y)return true;
    var yf=parseInt(x.yearFrom,10),yt=parseInt(x.yearTo,10),yy=parseInt(y,10);
    if(isNaN(yy))return false;
    if(!isNaN(yf)&&!isNaN(yt))return yy>=yf&&yy<=yt;
    if(!isNaN(yf))return yy===yf;
    if(!isNaN(yt))return yy===yt;
    return false;
  }
  function exactMatchValue(values,value){var l=lower(value);for(var i=0;i<values.length;i++)if(lower(values[i])===l)return values[i];return ''}
  function isYearToken(v){return /^\d{4}$/.test(String(v||''))}

  // Pre-index only valid, explicit years. A blank Year To does not create future years.
  var makes=uniq(DATA.map(function(x){return x.make}));
  var modelsByMake={},yearsByMakeModel={};
  DATA.forEach(function(x){
    var mk=lower(x.make),md=lower(x.model),key=mk+'||'+md;
    if(!modelsByMake[mk])modelsByMake[mk]=[];
    modelsByMake[mk].push(x.model);
    if(!yearsByMakeModel[key])yearsByMakeModel[key]=[];
    var a=parseInt(x.yearFrom,10),b=parseInt(x.yearTo,10);
    if(!isNaN(a)&&!isNaN(b)){for(var y=a;y<=b;y++)yearsByMakeModel[key].push(String(y));}
    else if(!isNaN(a)){yearsByMakeModel[key].push(String(a));}
    else if(!isNaN(b)){yearsByMakeModel[key].push(String(b));}
  });
  Object.keys(modelsByMake).forEach(function(k){modelsByMake[k]=uniq(modelsByMake[k])});
  Object.keys(yearsByMakeModel).forEach(function(k){yearsByMakeModel[k]=uniq(yearsByMakeModel[k]).sort(function(a,b){return parseInt(b,10)-parseInt(a,10)})});

  function currentModels(){return selectedMake?(modelsByMake[lower(selectedMake)]||[]):[]}
  function currentYears(){return (selectedMake&&selectedModel)?(yearsByMakeModel[lower(selectedMake)+'||'+lower(selectedModel)]||[]):[]}
  function closeMenus(except){[el.makeMenu,el.modelMenu,el.yearMenu].forEach(function(menu){if(menu!==except)menu.classList.remove('open')})}
  function optionList(values,query){query=lower(query);var out=!query?values:values.filter(function(v){return lower(v).indexOf(query)>-1});return out.slice(0,60)}
  function renderMenu(menu,values,input,onSelect){
    var list=optionList(values,input.value);
    if(!list.length){menu.innerHTML='<div class="home-vf-option-empty">No matching options</div>';menu.classList.add('open');return}
    menu.innerHTML=list.map(function(v){return '<div class="home-vf-option" role="option" data-value="'+esc(v)+'">'+esc(v)+'</div>'}).join('');
    menu.classList.add('open');

    // Mobile fix: do not select on pointerdown. Selecting on pointerdown blocks native
    // touch scrolling inside the dropdown. Select only on a real tap/click.
    Array.prototype.forEach.call(menu.querySelectorAll('.home-vf-option'),function(opt){
      var sx=0,sy=0,moved=false;

      opt.addEventListener('pointerdown',function(e){
        sx=e.clientX||0;sy=e.clientY||0;moved=false;
      },{passive:true});

      opt.addEventListener('pointermove',function(e){
        var dx=Math.abs((e.clientX||0)-sx),dy=Math.abs((e.clientY||0)-sy);
        if(dx>8||dy>8)moved=true;
      },{passive:true});

      opt.addEventListener('pointerup',function(e){
        if(moved)return;
        e.preventDefault();e.stopPropagation();preventGhostClickUntil=Date.now()+250;
        onSelect(opt.getAttribute('data-value'));closeMenus();
      });

      opt.addEventListener('click',function(e){
        if(Date.now()<preventGhostClickUntil){e.preventDefault();e.stopPropagation();return}
      });
    });
  }
  function bindDropdown(input,menu,getValues,onSelect,onType){
    input.addEventListener('focus',function(){if(input.disabled)return;closeMenus(menu);renderMenu(menu,getValues(),input,onSelect)});
    input.addEventListener('click',function(){if(input.disabled)return;setTimeout(function(){closeMenus(menu);renderMenu(menu,getValues(),input,onSelect)},0)});
    var timer;
    input.addEventListener('input',function(){
      clearTimeout(timer);if(input.disabled)return;closeMenus(menu);renderMenu(menu,getValues(),input,onSelect);
      timer=setTimeout(function(){onType(input.value)},70);
    });
  }

  bindDropdown(el.make,el.makeMenu,function(){return makes},function(v){
    selectedMake=v;el.make.value=v;selectedModel='';selectedYear='';el.model.value='';el.year.value='';updateFilterState();setTimeout(function(){el.model.focus()},80);
  },function(v){
    selectedMake=exactMatchValue(makes,v);selectedModel='';selectedYear='';el.model.value='';el.year.value='';updateFilterState();
  });
  bindDropdown(el.model,el.modelMenu,currentModels,function(v){
    selectedModel=v;el.model.value=v;selectedYear='';el.year.value='';updateFilterState();setTimeout(function(){el.year.focus()},80);
  },function(v){
    selectedModel=exactMatchValue(currentModels(),v);selectedYear='';el.year.value='';updateFilterState();
  });
  bindDropdown(el.year,el.yearMenu,currentYears,function(v){selectedYear=v;el.year.value=v;updateFilterState()},function(v){selectedYear=exactMatchValue(currentYears(),v);updateFilterState()});

  function updateFilterState(){
    el.model.disabled=!selectedMake;
    el.year.disabled=!(selectedMake&&selectedModel);
    el.model.placeholder=selectedMake?'Select model':'Select make first';
    el.year.placeholder=(selectedMake&&selectedModel)?'Select year':'Select model first';
  }

  function representativeImage(rows){var counts={},best='',bestCount=0;rows.forEach(function(x){var im=norm(x.image);if(!im)return;counts[im]=(counts[im]||0)+1;if(counts[im]>bestCount){best=im;bestCount=counts[im]}});return best}
  function makeSummary(rows){var vals=uniq(rows.map(function(x){return x.make}));return vals.slice(0,2).join(' / ')+(vals.length>2?' +'+(vals.length-2):'')}
  function modelSummary(rows){var vals=uniq(rows.map(function(x){return x.model}));return vals.slice(0,3).join(' / ')+(vals.length>3?' +'+(vals.length-3)+' more':'')}
  function fitmentCount(rows){var seen={},n=0;rows.forEach(function(x){var k=lower([x.make,x.model,yearLabel(x),countryLabel(x)].join('|'));if(!seen[k]){seen[k]=1;n++}});return n}
  function groupBySku(rows,terms){
    var map={},groups=[];
    rows.forEach(function(x){
      var key=norm(x.sku)||('NO-SKU-'+norm(x.image));
      if(!map[key]){map[key]={sku:key,rows:[],productHandle:'',score:0};groups.push(map[key])}
      map[key].rows.push(x);
      if(!map[key].productHandle&&norm(x.productHandle))map[key].productHandle=norm(x.productHandle);
      if(terms&&terms.length)map[key].score=Math.max(map[key].score,scoreRow(x,terms));
    });
    groups.forEach(function(g){g.image=representativeImage(g.rows);g.makes=makeSummary(g.rows);g.models=modelSummary(g.rows);g.count=fitmentCount(g.rows)});
    groups.sort(function(a,b){return (b.score-a.score)||a.makes.localeCompare(b.makes)||a.models.localeCompare(b.models)||a.sku.localeCompare(b.sku,undefined,{numeric:true})});
    return groups;
  }
  function scoreRow(x,terms){
    var make=lower(x.make),model=lower(x.model),sku=lower(x.sku),hay=lower([x.make,x.model,x.yearFrom,x.yearTo,x.country,x.sku].join(' ')),score=0;
    terms.forEach(function(w){
      if(isYearToken(w)&&coversYear(x,w))score+=35;
      else if(make===w)score+=40;
      else if(model===w)score+=40;
      else if(make.indexOf(w)>-1||model.indexOf(w)>-1)score+=25;
      else if(sku===w)score+=45;
      else if(hay.indexOf(w)>-1)score+=10;
    });
    return score;
  }
  function quickSearchRows(query){
    var terms=lower(query).split(/\s+/).filter(Boolean);
    if(!terms.length)return {rows:[],terms:[]};
    var rows=DATA.filter(function(x){
      var hay=lower([x.make,x.model,x.yearFrom,x.yearTo,x.country,x.sku].join(' '));
      return terms.every(function(w){return isYearToken(w)?coversYear(x,w):hay.indexOf(w)>-1});
    });
    return {rows:rows,terms:terms};
  }
  function structuredRows(){
    var mk=lower(selectedMake),md=lower(selectedModel);
    return DATA.filter(function(x){return lower(x.make)===mk&&lower(x.model)===md&&coversYear(x,selectedYear)});
  }

  function marketCountry(){return String(window.v2VfhMarketCountry||'AU').trim().toUpperCase()}
  function marketHandle(baseHandle){
    baseHandle=norm(baseHandle);
    if(!baseHandle)return '';
    if(marketCountry()==='AU')return baseHandle.replace(/-intl$/i,'');
    return /-intl$/i.test(baseHandle)?baseHandle:baseHandle+'-intl';
  }
  function productUrl(handle){handle=marketHandle(handle);return handle?('/products/'+encodeURIComponent(handle)):customizeLink}

  function status(title,text){el.results.innerHTML='<div class="home-vf-status"><strong>'+esc(title)+'</strong><span>'+esc(text)+'</span></div>'}
  function renderResults(){
    if(!currentMode)return status('Search for your vehicle','Use quick search or select Make, Model, and Year, then click Find My Wrap.');
    if(!currentGroups.length)return status('No matching wheel found','Check the spelling, try another search, or contact us with a steering wheel photo.');
    var visible=currentGroups.slice(0,shown);
    el.results.innerHTML='<div class="home-vf-result-head"><h3>Matching steering wheels</h3><span>'+esc(currentGroups.length)+' option'+(currentGroups.length===1?'':'s')+' found for '+esc(currentLabel)+'</span></div>'+ 
      '<div class="home-vf-grid">'+visible.map(function(g){
        var url=productUrl(g.productHandle),missing=!norm(g.productHandle);
        return '<div class="home-vf-card" tabindex="0" role="link" data-url="'+esc(url)+'">'+
          '<div class="home-vf-img"><img loading="lazy" src="'+esc(g.image)+'" alt="'+esc(g.makes+' '+g.models+' steering wheel')+'"></div>'+ 
          '<div class="home-vf-body">'+
            '<div class="home-vf-make">'+esc(g.makes)+'</div>'+ 
            '<div class="home-vf-model">'+esc(g.models)+'</div>'+ 
            '<div class="home-vf-card-text">Compare this steering wheel with yours. If it matches, click View Suitable Wrap to see matching wrap options.</div>'+ 
            '<div class="home-vf-chiprow"><span class="home-vf-chip">'+esc(g.sku)+'</span><span class="home-vf-chip">'+(g.count===1?'1 fitment':esc(g.count)+' fitments')+'</span></div>'+ 
            '<a class="home-vf-btn" href="'+esc(url)+'">'+(missing?'View Suitable Wrap':'View Suitable Wrap')+'</a>'+ 
          '</div>'+ 
        '</div>';
      }).join('')+'</div>'+ 
      (currentGroups.length>shown?'<button id="home-vf-load" class="home-vf-load" type="button">Show More Results</button>':'')+
      '<div class="home-vf-small-note">Showing '+esc(Math.min(shown,currentGroups.length))+' of '+esc(currentGroups.length)+' matching wheel options.</div>';
    var load=document.getElementById('home-vf-load');
    if(load)load.addEventListener('click',function(){shown+=pageSize;renderResults()});
  }
  function showResultsOnMobile(){if(window.innerWidth<720)setTimeout(function(){el.results.scrollIntoView({behavior:'smooth',block:'start'})},80)}

  function runQuickSearch(){
    closeMenus();var q=norm(el.search.value);
    if(!q){currentMode='';currentGroups=[];return status('Enter your vehicle','Try a make, model, year, or MD code, such as Toyota Corolla 2021.')}
    var found=quickSearchRows(q);currentMode='quick';currentLabel='“'+q+'”';shown=pageSize;currentGroups=groupBySku(found.rows,found.terms);renderResults();showResultsOnMobile();
  }
  function runStructuredSearch(){
    closeMenus();
    selectedMake=exactMatchValue(makes,el.make.value);
    selectedModel=exactMatchValue(selectedMake?(modelsByMake[lower(selectedMake)]||[]):[],el.model.value);
    selectedYear=exactMatchValue((selectedMake&&selectedModel)?(yearsByMakeModel[lower(selectedMake)+'||'+lower(selectedModel)]||[]):[],el.year.value);
    updateFilterState();
    if(!(selectedMake&&selectedModel&&selectedYear)){currentMode='';currentGroups=[];return status('Complete your vehicle details','Select an exact Make, Model, and Year before searching.')}
    currentMode='structured';currentLabel=selectedMake+' '+selectedModel+' '+selectedYear;shown=pageSize;currentGroups=groupBySku(structuredRows(),[]);renderResults();showResultsOnMobile();
  }

  el.searchBtn.addEventListener('click',runQuickSearch);
  el.filterBtn.addEventListener('click',runStructuredSearch);
  el.search.addEventListener('keydown',function(e){if(e.key==='Enter'){e.preventDefault();runQuickSearch()}});
  el.year.addEventListener('keydown',function(e){if(e.key==='Enter'){e.preventDefault();runStructuredSearch()}});

  function ignoreCardClick(target){return target.closest('a')||target.closest('button')||target.closest('input')||target.closest('.home-vf-menu')}
  el.results.addEventListener('click',function(e){
    if(Date.now()<preventGhostClickUntil){e.preventDefault();e.stopPropagation();return}
    var card=e.target.closest('.home-vf-card[data-url]');if(!card||ignoreCardClick(e.target))return;var url=card.getAttribute('data-url');if(url)window.location.href=url;
  });
  el.results.addEventListener('keydown',function(e){if((e.key==='Enter'||e.key===' ')&&e.target.classList.contains('home-vf-card')){e.preventDefault();var url=e.target.getAttribute('data-url');if(url)window.location.href=url}});
  document.addEventListener('pointerdown',function(e){
    // A fresh tap outside a dropdown option is a new user action, so do not let the previous ghost-click guard block it.
    if(Date.now()<preventGhostClickUntil&&!e.target.closest('.home-vf-option'))preventGhostClickUntil=0;
    if(e.target.closest('.home-vf-field'))return;closeMenus();
  },true);
  document.addEventListener('click',function(e){if(Date.now()<preventGhostClickUntil){e.preventDefault();e.stopPropagation()}},true);

  el.clear.addEventListener('click',function(e){
    e.preventDefault();selectedMake='';selectedModel='';selectedYear='';el.search.value='';el.make.value='';el.model.value='';el.year.value='';currentMode='';currentGroups=[];shown=pageSize;closeMenus();updateFilterState();renderResults();
  });

  updateFilterState();
  renderResults();
})();
